import { useIntl } from "react-intl";

import InformationPage from "components/GenericPage/InformationPage";
import { labels, titles } from "resources/resources";

function NominalWorkersRegister() {
  const intl = useIntl();

  const nominalWorkersRegisterData = [
    {
      title: null,
      content: [
        text(intl.formatMessage(labels.Label_Menu_CompanyServices_NominalWorkersRegisterIntro)),
      ],
    },
    {
      title: intl.formatMessage(labels.Label_Menu_CompanyServices_NominalWorkersRegisterScopeTitle),
      content: [
        text(intl.formatMessage(labels.Label_Menu_CompanyServices_NominalWorkersRegisterScope1)),
      ],
    },
    {
      title: intl.formatMessage(labels.Label_Menu_CompanyServices_NominalWorkersRegisterObjectivesTitle),
      content: [
        text(intl.formatMessage(labels.Label_Menu_CompanyServices_NominalWorkersRegisterObjectivesIntro)),
        text(intl.formatMessage(labels.Label_Menu_CompanyServices_NominalWorkersRegisterObjectivesBullet1)),
        text(intl.formatMessage(labels.Label_Menu_CompanyServices_NominalWorkersRegisterObjectivesBullet2)),
        text(intl.formatMessage(labels.Label_Menu_CompanyServices_NominalWorkersRegisterObjectivesBullet3)),
      ],
    },
    {
      title: intl.formatMessage(labels.Label_Menu_CompanyServices_NominalWorkersRegisterTitle),
      content: [
        text(intl.formatMessage(labels.Label_Menu_CompanyServices_NominalWorkersRegister1)),
      ],
    },
    {
      title: intl.formatMessage(labels.Label_Menu_CompanyServices_NominalWorkersRegisterAnalysisTitle),
      content: [
        text(intl.formatMessage(labels.Label_Menu_CompanyServices_NominalWorkersRegister2)),
        text(intl.formatMessage(labels.Label_Menu_CompanyServices_NominalWorkersRegister3)),
      ],
    },
  ];

  return (
    <InformationPage
      title={intl.formatMessage(titles.Title_Menu_Information_CompanyServices_NominalWorkersRegister)}
      data={nominalWorkersRegisterData}
    />
  );
}

const text = (label) => {
  return label + "\n\n";
};

export default NominalWorkersRegister;
